import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DoggyhubPage } from './doggyhub.page';

const routes: Routes = [
  {
    path: 'tabs',
    component: DoggyhubPage,
    children: [
      {
        path: 'articles',
        loadChildren: () =>
          import('./articles/articles.module').then(
            (m) => m.ArticlesPageModule
          ),
      },
      {
        path: 'dailyfact',
        loadChildren: () =>
          import('./dailyfact/dailyfact.module').then(
            (m) => m.DailyfactPageModule
          ),
      },
      {
        path: 'behavior',
        loadChildren: () =>
          import('./behaviors/behaviors.module').then(
            (m) => m.BehaviorsPageModule
          ),
      },
      {
        path: '',
        redirectTo: '/doggyhub/tabs/articles',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    redirectTo: '/doggyhub/tabs/articles',
    pathMatch: 'full',
  },
  {
    path: 'behaviors',
    loadChildren: () =>
      import('./behaviors/behaviors.module').then((m) => m.BehaviorsPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DoggyhubPageRoutingModule {}
